module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic79.06ab411.woff2";